export const REGULAR_EXPRESSION = {
  CHECK_WORK_SPACING: '^\\s*(?:\\S{1,22})(?:[\\n ]+\\S{1,22})*\\s*$'

};
